angular.module('unica_approvation_list.approvation_list_controllers')

.controller('ApprovationListListZmController',
	function(
		$rootScope, $scope, $state, $stateParams,
		ApprovationListListService
	) {

	$scope.approvationLists = [];

	$scope.loadApprovationLists = function() {
		$scope.showLoader();

		ApprovationListListService
			.listZm( $rootScope.currentUser.id )
			.then(function(data) {
				$scope.hideLoader();

				var now = new Date();
				now = Math.floor( now.getTime() / 1000 );

				for ( var i = 0; i < data.length; i++ ) {
					data[i].compile = ( data[i].status == 'compile' && data[i].invitation_list.zm_expiration_date > now ? true : false );

					if ( !data[i].invitation_list.all_stage ) {
						data[i].invitation_list.stage.from_date = moment.unix( data[i].invitation_list.stage.from_date ).toDate();
						data[i].invitation_list.stage.from_time = data[i].invitation_list.stage.from_date;
						data[i].invitation_list.stage.to_date   = moment.unix( data[i].invitation_list.stage.to_date ).toDate();
						data[i].invitation_list.stage.to_time   = data[i].invitation_list.stage.to_date;
					}

					data[i].exportSelected    = false;
					data[i].exportSelectedUrl = '';
				}

				$scope.approvationLists = $scope.approvationLists.concat( data );
			});
	};

	$scope.loadApprovationLists();


	$scope.prepareExportSelectedUrl = function( approvationListId ) {
		$scope.showLoader();

		ApprovationListListService
			.exportList( approvationListId )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {

					angular.forEach($scope.approvationLists, function(approvationList, key) {
						if ( approvationList.id == approvationListId ) {
							$scope.approvationLists[key]['exportSelected']    = true;
							$scope.approvationLists[key]['exportSelectedUrl'] = url;
						}
					});
				}
			});
	};

});
